// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2MbQl","App-logo":"App_App-logo__1zAcM","App-logo-spin":"App_App-logo-spin__1w9zc","App-header":"App_App-header__29OXp","App-link":"App_App-link__36ctI"};